import {DatePicker, Form, Modal, TimePicker, shiftScore, Col} from "antd";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useStore} from "../../../../hooks/useStore";
import {minuteToString} from "../../../../utils/helpers";

type ShiftScoreDetailModalProps = {
    shiftScore: {},
    visibility: Boolean,
    onCancel: () => void
};

const ShiftScoreDetailModal = ({shiftScore, visibility, onCancel}): ShiftScoreDetailModalProps => {
    const {t} = useTranslation(["shiftScore", "courierStatuses"]);
    const stores = useStore();
    const [confirmLoading, setConfirmLoading] = useState();
    const {
        reportDate = "",
        fullname = "",
        tckn = "",
        cellPhone = "",
        companyName = "",
        companyCode = "",
        subCompanyName = "",
        subCompanyCode = "",
        shiftStartTime = "",
        shiftEndTime = "",
        startTime = "",
        startStatus = "",
        endTime = "",
        endStatus = "",
        endReason = "",
        workTimeMinute = "",
        busyTimeMinute = "",
        packageCount = "",
        verifiedPackageCount = "",
        shiftStartDistance = "",
        shiftEndDistance = "",
        lateStart = "",
        earlyEnd = ""
    } = shiftScore || {};

    return (
        <Modal
            visible={visibility}
            onCancel={onCancel}
            confirmLoading={confirmLoading}
            footer={null}
        >
            <div>
                <p>
                    <b>{t("fields.date", {ns: "common"})}</b> : {reportDate}
                </p>
                <p>
                    <b>{t("fields.courier", {ns: "common"})}</b> : {fullname}
                </p>
                <p>
                    <b>{t("fields.courierIdNo", {ns: "common"})}</b> : {tckn}
                </p>
                <p>
                    <b>{t("fields.courierPhone", {ns: "common"})}</b> : {cellPhone}
                </p>
                <p>
                    <b>{t("fields.company", {ns: "common"})}</b> : {companyName}
                </p>
                <p>
                    <b>{t("fields.companyCode", {ns: "common"})}</b> : {companyCode}
                </p>
                <p>
                    <b>{t("fields.subcompany", {ns: "common"})}</b> : {subCompanyName}
                </p>
                <p>
                    <b>{t("fields.subCompanyCode", {ns: "common"})}</b> : {subCompanyCode}
                </p>
                <p>
                    <b>{t("shiftScore.shiftStartTime", {ns: "shiftScore"})}</b> : {shiftStartTime}
                </p>
                <p>
                    <b>{t("shiftScore.shiftEndTime", {ns: "shiftScore"})}</b> : {shiftEndTime}
                </p>
                <p>
                    <b>{t("shiftScore.startTime", {ns: "shiftScore"})}</b> : {startTime}
                </p>
                <p>
                    <b>{t("shiftScore.startStatus", {ns: "shiftScore"})}</b> :{" "}
                    {t(startStatus, {ns: "courierStatuses"})}
                </p>
                <p>
                    <b>{t("shiftScore.endTime", {ns: "shiftScore"})}</b> : {endTime}
                </p>
                <p>
                    <b>{t("shiftScore.endStatus", {ns: "shiftScore"})}</b> :{" "}
                    {t(endStatus, {ns: "courierStatuses"})}
                </p>
                <p>
                    <b>{t("shiftScore.endReason", {ns: "shiftScore"})}</b> : {endReason}
                </p>
                <p>
                    <b>
                        {t("shiftScore.workTime", {ns: "shiftScore"})} - (
                        {t("units.minute.short", {ns: "common"})})
                    </b>{" "}
                    : {workTimeMinute}
                </p>
                <p>
                    <b>
                        {t("shiftScore.workTime", {ns: "shiftScore"})} - (
                        {t("units.hour.long", {ns: "common"})})
                    </b>{" "}
                    : {minuteToString(workTimeMinute)}
                </p>

                {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                    <>
                        <p>
                            <b>
                                {t("shiftScore.busyTimeMinute", {ns: "shiftScore"})} - (
                                {t("units.minute.short", {ns: "common"})})
                            </b>{" "}
                            : {busyTimeMinute}
                        </p>
                    </>
                )}
                <p>
                    <b>{t("shiftScore.packageCount", {ns: "shiftScore"})}</b> : {packageCount}
                </p>
                <p>
                    <b>{t("shiftScore.verifiedPackageCount", {ns: "shiftScore"})}</b> :{" "}
                    {verifiedPackageCount}
                </p>

                <p>
                    <b>
                        {t("shiftScore.shiftStartDistance", {ns: "shiftScore"})} - (
                        {t("units.meter.long", {ns: "common"})})
                    </b>{" "}
                    : {shiftStartDistance}
                </p>
                <p>
                    <b>
                        {t("shiftScore.shiftEndDistance", {ns: "shiftScore"})} - (
                        {t("units.meter.long", {ns: "common"})})
                    </b>{" "}
                    : {shiftEndDistance}
                </p>
                {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                    <>
                        <p>
                            <b>
                                {t("shiftScore.lateShiftStart", {ns: "shiftScore"})} - (
                                {t("units.minute.short", {ns: "common"})})
                            </b>{" "}
                            : {lateStart}
                        </p>
                        <p>
                            <b>
                                {t("shiftScore.earlyShiftEnd", {ns: "shiftScore"})} - (
                                {t("units.minute.short", {ns: "common"})})
                            </b>{" "}
                            : {earlyEnd}
                        </p>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default ShiftScoreDetailModal;
